'use strict';

import { Signal } from 'signals';
import L from 'leaflet';
import 'leaflet.locationfilter';

class LocationFilter {

  constructor(lmap) {
    this._lmap = lmap;
    this._locationFilter = new L.LocationFilter({
      buttonPosition: 'bottomleft',
    }).addTo(this._lmap);

    this.selectionChanged = new Signal();

    this._locationFilter.on('change', () => this._onLocationFilterChanged());
    this._locationFilter.on('enabled', () => this._onLocationFilterChanged());
    this._locationFilter.on('disabled', () => this._onLocationFilterChanged());
  }

  getBounds() {
    if (!this._locationFilter.isEnabled()) return null;
    return this._locationFilter.getBounds();
  }

  _onLocationFilterChanged() {
    this.selectionChanged.dispatch(this.getBounds());
  }

}

module.exports = LocationFilter;



/** WEBPACK FOOTER **
 ** D:/2016/2016 - ISI/grantorino/frontend/../../../../Marco/Dropbox (ISI Foundation)/2016 - ISI/grantorino/frontend/src/js/views/map/locationfilter/LocationFilter.es6
 **/